document.addEventListener("DOMContentLoaded", function () {

  let isLoading = false;

  const sectionEl = document.querySelector('#product-grid');
  const liveSectionId = sectionEl
    ? sectionEl.closest('.shopify-section')?.id?.replace('shopify-section-', '')
    : null;

  function initInfiniteScroll() {
    const paginationEl = document.querySelector(".pagination-container");
    if (!paginationEl) return;

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !isLoading) {
        loadNextPage();
      }
    }, { rootMargin: "200px" });

    observer.observe(paginationEl);
  }

  function loadNextPage() {
    // pagination__item--prev is actually the NEXT page link in this theme
    const nextLink = document.querySelector(".pagination__item--prev[href]");
    if (!nextLink) return;

    isLoading = true;

    // Fetch full page (no section_id) so shopify-section wrapper is present
    const url = nextLink.href;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newItems = doc.querySelectorAll("#product-grid .grid__item");
        const grid = document.querySelector("#product-grid");

        newItems.forEach(item => {
          // Move modals to body BEFORE appending item to live DOM
          item.querySelectorAll('quick-add-modal').forEach(modal => {
            if (liveSectionId) modal.dataset.section = liveSectionId;
            modal.setAttribute('data-moved', 'true');
            document.body.appendChild(modal);
          });

          grid.appendChild(item);
        });

        // Manually wire modal-opener clicks
        grid.querySelectorAll('modal-opener:not([data-wired])').forEach(opener => {
          opener.setAttribute('data-wired', 'true');
          const button = opener.querySelector('button');
          if (!button) return;
          button.addEventListener('click', () => {
            const modal = document.querySelector(opener.getAttribute('data-modal'));
            if (modal) modal.show(button);
          });
        });

        const newPagination = doc.querySelector(".pagination-container");
        const oldPagination = document.querySelector(".pagination-container");

        if (oldPagination) oldPagination.remove();

        if (newPagination) {
          grid.after(newPagination);
          isLoading = false;
          initInfiniteScroll();
        }
      })
      .catch(() => {
        isLoading = false;
      });
  }

  initInfiniteScroll();

  document.addEventListener("shopify:section:load", initInfiniteScroll);
});
